import { isValidEmail, isValidPhone } from './CommonValidators';
// Evitamos importar a classe Lead inteira para não criar dependência circular forte, 
// definimos apenas a interface do que precisamos validar
interface ValidatableLead {
    name: string;
    email?: string; // Aqui é private na classe, mas acessível via getter ou se passarmos o valor direto
    // Na classe Lead, email é private. O Validator não vai conseguir acessar this.email se for externo.
    // Solução: Lead passa os valores para o validator.
}

/**
 * LeadValidator
 * Centraliza regras de validação da entidade Lead
 */
export class LeadValidator {

    static validateName(name: string): void {
        if (!name || name.trim().length < 2) {
            throw new Error('Nome do lead deve ter pelo menos 2 caracteres');
        }
    }

    static validateEmail(email: string): void {
        if (email && !isValidEmail(email)) {
            throw new Error('Email inválido');
        }
    }

    static validateWhatsApp(whatsApp: string): void {
        if (whatsApp && !isValidPhone(whatsApp)) {
            throw new Error('WhatsApp deve estar no formato válido');
        }
    }

    static validateValue(value: number): void {
        if (value < 0) {
            throw new Error('Valor não pode ser negativo');
        }
    }

    static validateStage(status: string, stage: string): void {
        // Stage é obrigatório apenas para negociações abertas
        if (status === 'open' && (!stage || stage.trim() === '')) {
            throw new Error('Etapa da negociação é obrigatória para negociações abertas');
        }
    }
}
